import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, HStack, Icon, Center, Box } from '@wegroup/design-system';
import useToggleCompanyOverview from '../../hooks/useToggleCompanyOverview';

const CompanyScanBottomBarDrawerHeader: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { hideOverview } = useToggleCompanyOverview();
  const { t } = useTranslation();

  const handleOnEscapePress = (event: KeyboardEvent) => {
    if (event.key === 'Escape') hideOverview();
  };

  useEffect(() => {
    window.addEventListener('keydown', handleOnEscapePress);

    return () => window.removeEventListener('keydown', handleOnEscapePress);
  }, []);

  return (
    <Box
      data-test-id="COMPANY-SCAN_DRAWER_HEADER-BUTTON"
      onClick={hideOverview}
      p="5"
      cursor="pointer"
      borderBottom="1px solid"
      borderColor="gray.50"
      _hover={{ bg: 'gray.ultraLight' }}
      transition="0.2s"
      pos="relative"
    >
      <Box pos="absolute" right="2" top="50%" transform="translateY(-50%)">
        <Icon name="GeneralActionsCloseOrRemove" boxSize={7} />
      </Box>
      <Center>
        <HStack>
          <Text textAlign="center" textStyle="normalBody">
            {t('COMPANY-SCAN_QUESTION-FLOW_TOP-BAR_TITLE')}
          </Text>
          <Center>
            <Icon name="GeneralActionsChevronDownRounded" boxSize="4" />
          </Center>
        </HStack>
      </Center>
    </Box>
  );
};

export default CompanyScanBottomBarDrawerHeader;
